import { api } from "../client";
import { Config, ConfigMutate } from "../types";
import {
  MessageThreadExtraFields,
  MessageThreadFields,
  PartialMessageThreadExtraFields,
  PartialMessageThreadFields,
} from "../schema";

type ApiRequestConfig = Config<MessageThreadFields, MessageThreadExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialMessageThreadFields,
  PartialMessageThreadExtraFields
>;

export const getMessageThreads = (config?: ApiRequestConfig) => {
  return api.get<MessageThreadFields, MessageThreadExtraFields>(
    `message_threads`,
    config
  );
};

export const getMessageThread = (id: number, config?: ApiRequestConfig) => {
  return api.get<MessageThreadFields, MessageThreadExtraFields>(
    `message_threads/${id}`,
    config
  );
};

export const createMessageThread = (config?: ApiRequestConfigMutate) => {
  return api.create<MessageThreadFields, MessageThreadExtraFields>(
    `message_threads`,
    config
  );
};

export const updateMessageThread = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<MessageThreadFields, MessageThreadExtraFields>(
    `message_threads/${id}`,
    config
  );
};

export const deleteMessageThread = (id: number) => {
  return api.remove<MessageThreadFields, MessageThreadExtraFields>(
    `message_threads/${id}`
  );
};
